__turbopack_context__.v({
  "block": "vjMKHa_block",
  "chevron": "vjMKHa_chevron",
  "chevronBtn": "vjMKHa_chevronBtn",
  "glass": "vjMKHa_glass",
  "kbd": "vjMKHa_kbd",
  "leaf": "vjMKHa_leaf",
  "leaves": "vjMKHa_leaves",
  "nav": "vjMKHa_nav",
  "row": "vjMKHa_row",
  "rowLink": "vjMKHa_rowLink",
  "scroll": "vjMKHa_scroll",
  "search": "vjMKHa_search",
  "searchText": "vjMKHa_searchText",
  "sectionHead": "vjMKHa_sectionHead",
  "sectionIcon": "vjMKHa_sectionIcon",
  "tree": "vjMKHa_tree",
});
